import { CompilationSortOption } from "@turtlewave/types";

/**
 * Build a content detail path, preserving compilation context
 */
export function contentDetailPath(
  idOrSlug: string,
  compilationId?: string | null,
): string {
  const base = `/content/${idOrSlug}`;
  return compilationId ? `${base}?compilation=${compilationId}` : base;
}

/**
 * Determine exit destination based on context
 * Priority: referrer > compilation page > gallery
 */
export function getExitPath(
  compilationId: string | null,
  referrer?: string | null,
): string {
  if (referrer) return referrer;
  if (compilationId) return `/compilations/${compilationId}`;
  return "/gallery";
}

/**
 * Build a compilation detail path, preserving compilation context
 */
export function compilationDetailPath(
  compilationId: string,
  sortBy?: CompilationSortOption,
): string {
  const base = `/compilations/${compilationId}`;
  return sortBy ? `${base}?sortBy=${sortBy}` : base;
}
